import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Page from '../../../shared/components/ui/page/Page';
import pathRouts from '../../../shared/enums/pathRoute';
import iconsList from '../../../shared/components/ui/icons/iconsList';
import RealisticIsraelText from '../../../shared/components/pages/realisticIsrael/realisticIsraelText/RealisticIsraelText';
import RealisticIsraelCoursesWidget from './realisticIsraelCoursesWidget/RealisticIsraelCoursesWidget';
import RealisticIsraelCourses from '../../../shared/components/pages/realisticIsrael/realisticIsraelCourses/RealisticIsraelCourses';
import classes from './RealisticIsraelPage.module.css';

const RealisticIsraelPage = () => {

    const navigate = useNavigate();
    const { texts, lang } = useSelector(state => state.translate);
    const generalData = useSelector((state) => state.uiData.general);

    return (
        <Page title={texts.realisticIsraelName} icon={iconsList.realisticIsrael} onBack={() => navigate(`/${pathRouts.HOME}`)}>
            <div className={classes.RealisticIsraelPage}>
                <RealisticIsraelText description={texts?.realisticIsraelDescriptionTeacher} link={generalData.realisticIsrael.linkMoodleSupport?.[lang]} linkText={texts.GatheringInformationOnSupportForTeachersInMoodle} />
                <div className={classes.RealisticIsraelCourses}>
                    <div className={classes.ButtonsRow}>
                        <RealisticIsraelCourses buttonLink={generalData.realisticIsrael.moodleBtn} buttonText={texts.realisticIsraelMoodleBtn} showIcon={true} />
                        <RealisticIsraelCourses buttonLink={generalData.realisticIsrael.studentViewBtn?.[lang]} buttonText={texts.realisticIsraelStudentBtn} showMoodleIcon={false} />
                    </div>
                    <RealisticIsraelCoursesWidget />
                </div>
            </div>
        </Page>
    );
};

export default RealisticIsraelPage;
